import { render, staticRenderFns } from "./reportdetail.vue?vue&type=template&id=5444ecfa&scoped=true&"
import script from "./reportdetail.vue?vue&type=script&lang=js&"
export * from "./reportdetail.vue?vue&type=script&lang=js&"
import style0 from "./reportdetail.vue?vue&type=style&index=0&id=5444ecfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444ecfa",
  null
  
)

export default component.exports